// Tom Select wrapper
import TomSelect from "tom-select";
import {IMuWidget} from "./IMuWidget";
import {SearchSelectorItem} from "./SearchSelector";

export class UiSelect extends IMuWidget
{
	private tomSelect: TomSelect;

	public canAddItem: boolean = true;

	public multiple: boolean = true;

	public options: SelectItem[] = [];

	protected searchCallbackField : SelectSearchCallback;

	protected searchPromiseCallbackField : SelectSearchPromiseCallback;

	private useLoad: boolean;

	public set searchCallback(callback: SelectSearchCallback) {
		const reinit = !this.searchCallbackField;
		this.searchCallbackField = callback;
		if (reinit) this.initTomSelect();
	}

	public set searchPromiseCallback(callback: SelectSearchPromiseCallback) {
		const reinit = !this.searchPromiseCallbackField;
		this.searchPromiseCallbackField = callback;
		if (reinit) this.initTomSelect();
	}

	beforeIndex()
	{
		this.muRegisterEvent('change', 'input', 'focus', 'blur');
		this.container.innerHTML = '<select mu-id="input"'
			+ (this.multiple ? ' multiple="multiple"' : '')
			+ '><option value="foo">Foo</option></select>';
	}

	afterIndex() {
		this.initTomSelect();
	}

	initTomSelect() {
		if (this.tomSelect) this.tomSelect.destroy();
		const createHandler = (name: string) => (evt: Event) => this.muDispatchEvent(name, evt);
		const setting: Record<string, any> = {
			valueField: "id",
			labelField: "name",
			create: this.canAddItem,
			onBlur: createHandler('blur'),
			onChange: createHandler('change'),
			onFocus: createHandler('focus'),
		};
		this.useLoad = this.searchCallback != null || this.searchPromiseCallback != null;
		if (this.useLoad)
			setting.load = (query: string, callback: any) => this.doSearch(query, callback);

		this.tomSelect = new TomSelect(this.ui.input, setting);

		this.setOptions(this.options);
	}

	public addOption(option: SelectItem) {
		this.tomSelect.addOption(option);
	}


	public setOptions(options: SelectItem[]) {
		this.tomSelect.clearOptions();
		this.tomSelect.addOptions(this.options);
	}

	public get value(): SelectItemId|SelectItemId[]
	{
		return this.tomSelect.getValue();
	}

	public set value(v)
	{
		if (this.useLoad) {
			// check and load missing
			const missing = [];
			for(const val of Array.isArray(v) ? v : [v]) {
				if (!this.tomSelect.getOption(val)) missing.push(val);
			}
			if (missing.length) {
				this.doSearch(missing).then(data => {
					this.tomSelect.setValue(v);
				});
				return;
			}
		}
		this.tomSelect.setValue(v);
	}

	override muBindData(srcData: any) {
		this.value = srcData;
	}

	override muFetchData(): any {
		return this.value;
	}

	private doSearch(query: string|SelectItemId[], callback: ((data: any)=>void)|null = null): Promise<any> {
		if (this.searchCallback) {
			return new Promise<any>((resolve, reject) => {
				this.searchCallback(query, data => {
					if (callback) callback(data);
					resolve(data);
				});
			});
		}
		else if (this.searchPromiseCallback) {
			const prom = this.searchPromiseCallback(query);
			if (callback) prom.then(data => callback(data));

			return prom;
		}
		else throw "No callback";
	}
}

type SelectItemId = string;

type SelectItem = any|{id:SelectItemId, name?:string};

type SelectSearchCallback = (term : string|SelectItemId[], resolve: (res : SearchSelectorItem[]) => void) => void;

type SelectSearchPromiseCallback = (term : string|SelectItemId[]) => Promise<any>;
